import { render, staticRenderFns } from "./AgroTable.vue?vue&type=template&id=7ef33312&scoped=true&"
import script from "./AgroTable.vue?vue&type=script&lang=ts&"
export * from "./AgroTable.vue?vue&type=script&lang=ts&"
import style0 from "./agroTable.scss?vue&type=style&index=0&id=7ef33312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef33312",
  null
  
)

export default component.exports